import { Component, OnInit } from '@angular/core';
import { AssignJeevesDefaultsComponent, JeevesDeliveryAddressesService } from 'gung-standard-jeeves';
import {
  SelectedCustomerService,
  Customer,
  AuthService,
  AvailabilityService,
  CartService,
  CustomerContactService,
  CustomerService,
  GungFlowService,
  CartRow,
  CustomerContact,
  GungFlow
} from 'gung-standard';
import { DateUtilService } from 'gung-common';

@Component({
    selector: 'colmec-assign-jeeves-defaults',
    templateUrl: './colmec-assign-jeeves-defaults.component.html',
    styleUrls: ['./colmec-assign-jeeves-defaults.component.scss'],
    standalone: false
})
export class ColmecAssignJeevesDefaultsComponent extends AssignJeevesDefaultsComponent implements OnInit {
  constructor(
    protected selectedCustomerService: SelectedCustomerService,
    protected customerService: CustomerService,
    protected customerContactService: CustomerContactService,
    protected gungFlowService: GungFlowService,
    protected authService: AuthService,
    protected cartService: CartService,
    protected availabilityService: AvailabilityService,
    protected dateUtilService: DateUtilService,
    protected jeevesDeliveryAddressesService: JeevesDeliveryAddressesService
  ) {
    super(
      selectedCustomerService,
      customerService,
      customerContactService,
      gungFlowService,
      authService,
      cartService,
      availabilityService,
      dateUtilService,
      jeevesDeliveryAddressesService
    );
  }

  protected setValues(
    customer: Customer,
    flow: GungFlow,
    user,
    customerContacts: CustomerContact[],
    billingCustomer?: Customer,
    cartRows?: CartRow[]
  ) {
    super.setValues(customer, flow, user, customerContacts, billingCustomer, cartRows);

    this.checkout.extra.procargs.ftgpostnr = customer.extra.fr.ftglevpostnr;
    this.checkout.extra.procargs.ordlevadr4 = customer.extra.fr.ftgpostlevadr3;
    this.checkout.extra.procargs.ordlevadr3 = customer.extra.fr.ftgpostadr5;
  }
  ngOnInit() {
    super.ngOnInit();
  }
}
